module.exports = __webpack_public_path__ + "static/media/respect.41f87860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/hands/respect.svg
// module id = 36
// module chunks = 0